export default () => parseInt(Math.random() * 10000, 10)
